import { useTranslation } from 'react-i18next';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import BackToFleetButton from '../../components/feature/BackToFleetButton';
import { MotoCard } from '../home/components/FleetCards';
import { motorcycles } from '../../mocks/motorcycles';

export default function MotorcyclesPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero banner */}
      <section className="relative h-64 flex items-end overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${motorcycles[0].image})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-navy-900/50 via-navy-900/30 to-navy-900/80" />
        </div>
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8">
          <h1 className="text-4xl md:text-5xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
            {t('fleet.tabMotorcycles')}
          </h1>
          <p className="text-white/80 mt-2 text-lg">{t('fleet.tabMotorcyclesDesc')}</p>
        </div>
      </section>

      {/* Barre navigation propre */}
      <div className="bg-white border-b border-sand-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <BackToFleetButton />
        </div>
      </div>

      {/* Cards */}
      <main className="py-16 bg-gradient-to-b from-white to-sand-50/40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8">
            {motorcycles.map((moto) => (
              <MotoCard key={moto.id} moto={moto} />
            ))}
          </div>
        </div>
      </main>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}